import styled from "@emotion/styled";

export const ArticleLeadingImageContainer = styled.div``;
